module.exports = __webpack_public_path__ + "static/media/fire_shoot.4d56236c.png";